import { Fragment } from "react";

import { translate } from "app/filters/i18nFilter";
import { linksDataAutomation } from "app/pages/activation/components/Header/Links/dataAutomationKeys";
import { headerLinksTexts } from "app/pages/activation/components/Header/Links/texts";
import { Link } from "app/pages/activation/components/Link/Link";
import { TOPICS_WRAPPER_ID } from "app/pages/activation/components/Topics/constants";
import { activationTracking } from "app/pages/activation/services/tracking";
import { useAlertsPageNavigation } from "app/pages/activation-alerts/hooks/useAlertsPageNavigation";
import { BENCHMARK_TRACKER_REPORT_ROUTE } from "app/pages/benchmark-tracker";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import * as SC from "./styles";

export type LinksSchema = {
    defaultDuration: string;
    activationId: string;
    benchmarkId: string;
    isAlertsAvailable: boolean;
};

export const Links = ({ defaultDuration, benchmarkId, isAlertsAvailable, activationId }: LinksSchema) => {
    const { country, timeGranularity, webSource } = proNavigator.getParams();
    const { navigateToAlerts } = useAlertsPageNavigation();

    const track = activationTracking.home;

    const links = [
        {
            label: translate(headerLinksTexts.benchmark),
            enabled: true,
            onClick: async () => {
                track.trackUserClickQuickLink(translate(headerLinksTexts.benchmark));

                await proNavigator.go(BENCHMARK_TRACKER_REPORT_ROUTE, {
                    key: benchmarkId,
                    country,
                    granularity: timeGranularity,
                    webSource,
                    duration: defaultDuration,
                });
            },
        },
        {
            label: translate(headerLinksTexts.topics),
            enabled: true,
            onClick: () => {
                track.trackUserClickQuickLink(translate(headerLinksTexts.topics));

                document.getElementById(TOPICS_WRAPPER_ID)?.scrollIntoView({ behavior: "smooth" });
            },
        },
        {
            label: translate(headerLinksTexts.alerts),
            enabled: isAlertsAvailable,
            onClick: async () => {
                await navigateToAlerts({ key: activationId, country });
            },
        },
    ];

    return (
        <SC.Container data-automation={linksDataAutomation.container}>
            <SC.Title data-automation={linksDataAutomation.title}>{translate(headerLinksTexts.title)}:</SC.Title>

            {links.map(({ label, onClick, enabled }) => (
                <Fragment key={label}>
                    {enabled ? (
                        <Link
                            label={label}
                            onClick={onClick}
                            dataAutomation={linksDataAutomation.link(label)}
                        />
                    ) : null}
                </Fragment>
            ))}
        </SC.Container>
    );
};
